import React from "react";
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Alert } from "@material-ui/lab";
import { HAKLAI_NO_TAX_OUTCOME_TEXTS } from "./haklaiAnalysisOutcomeTexts";

const OUTCOME_STYLE = {
  width: "100%",
  boxSizing: "border-box",
  direction: "rtl",
  textAlign: "right",
  alignItems: "flex-start"
};
const TITLE_STYLE = { fontWeight: 800 };
const REPORTING_NOTE_STYLE = { marginTop: 8 };

const useStyles = makeStyles({
  alert: {
    "& .MuiAlert-icon": {
      marginLeft: 12,
      marginRight: 0
    }
  }
});

const HaklaiNoTaxOutcome = () => {
  const classes = useStyles();

  return (
    <Alert className={classes.alert} severity="success" style={OUTCOME_STYLE}>
      <Typography variant="h6" style={TITLE_STYLE}>
        {HAKLAI_NO_TAX_OUTCOME_TEXTS.title}
      </Typography>
      <Typography variant="body1">
        {HAKLAI_NO_TAX_OUTCOME_TEXTS.explanation}
      </Typography>
      <Typography variant="body2" style={REPORTING_NOTE_STYLE}>
        {HAKLAI_NO_TAX_OUTCOME_TEXTS.reportingNote}
      </Typography>
    </Alert>
  );
};

export default React.memo(HaklaiNoTaxOutcome);
